import React from 'react'
import RegVinXS from '../../../components/images/abruzzowines/intestato/CantineAbruzzoW500.png';
import RegVinS from '../../../components/images/abruzzowines/intestato/CantineAbruzzoW800.png';
import RegVinM from '../../../components/images/abruzzowines/intestato/CantineAbruzzoW1200.png';
import RegVinL from '../../../components/images/abruzzowines/intestato/CantineAbruzzoW1600.png';
import RegVinXL from '../../../components/images/abruzzowines/intestato/CantineAbruzzoW2000.png';
import RegVinXXL from '../../../components/images/abruzzowines/intestato/CantineAbruzzoW3500.png';

import SwinesXS from '../../../components/images/choosewines/intestato/ScegliereViniW500.png';
import SwinesS from '../../../components/images/choosewines/intestato/ScegliereViniW800.png';
import SwinesM from '../../../components/images/choosewines/intestato/ScegliereViniW1200.png';
import SwinesL from '../../../components/images/choosewines/intestato/ScegliereViniW1600.png';
import SwinesXL from '../../../components/images/choosewines/intestato/ScegliereViniW2000.png';
import SwinesXXL from '../../../components/images/choosewines/intestato/ScegliereViniW3500.png';

import DWXS from '../../../components/images/tastewines/intestato/DegustationW500.png';
import DWS from '../../../components/images/tastewines/intestato/DegustationW800.png';
import DWM from '../../../components/images/tastewines/intestato/DegustationW1200.png';
import DWL from '../../../components/images/tastewines/intestato/DegustationW1600.png';
import DWXL from '../../../components/images/tastewines/intestato/DegustationW2000.png';
import DWXXL from '../../../components/images/tastewines/intestato/DegustationW3500.png';

import VitXS from '../../../components/images/vitigno/intestato/UvaggioWd500.png';
import VitS from '../../../components/images/vitigno/intestato/UvaggioWd800.png';
import VitM from '../../../components/images/vitigno/intestato/UvaggioWd1200.png';
import VitL from '../../../components/images/vitigno/intestato/UvaggioWd1600.png';
import VitXL from '../../../components/images/vitigno/intestato/UvaggioWd2000.png';
import VitXXL from '../../../components/images/vitigno/intestato/UvaggioWd3500.png';

import TiptXS from '../../../components/images/tipologia/intestato/TipologiaWd500.png';
import TiptS from '../../../components/images/tipologia/intestato/TipologiaWd800.png';
import TiptM from '../../../components/images/tipologia/intestato/TipologiaWd1200.png';
import TiptL from '../../../components/images/tipologia/intestato/TipologiaWd1600.png';
import TiptXL from '../../../components/images/tipologia/intestato/TipologiaWd2000.png';
import TiptXXL from '../../../components/images/tipologia/intestato/TipologiaWd3500.png';
import './headlink.scss';

/*
* Function element for items head links of navbar.
* August 19st, 2022
*/
export function NavHeadLinks({title, picXS, picS, picM, picL, picXL, picXXL}) {
    return (
        <>
            <div className='theme--header'>
                <p className="header__title">{title}</p> 
            </div>
            <div className="subheader__pics">
                <img src={picL}  alt="Header of region pic" srcSet={`${picXS} 400w, ${picS} 800w, ${picM} 1200w, ${picL} 1600w, ${picXL} 2000w, ${picXXL} 3500w`}  
                sizes="(max-width: 500px) 500px, (max-width: 800px) 800px, (max-width: 1200px) 1200px, (max-width: 1600px) 1600px, (max-width: 1920px) 2000px, (max-width: 3500px) 3500px, 2000px"/> 
            </div>
        </>
    )
}

/*
* Function element for items head on home page.
* August 19st, 2022
*/
export function ExhibitorHead({title, picXS, picS, picM, picL}) {
    return (
        <>
            <p className="exhibitor--subheader__title">{title}</p>   
            <div className="exhibitor--subheader">
                <img src={picL}  alt="Wine bottles pic" srcSet={`${picXS} 400w, ${picS} 500w, ${picM} 800w, ${picL} 1200w`} 
                sizes="(max-width: 460px) 400px, (max-width: 500px) 500px, (max-width: 800px) 800px, 1200px"/>
            </div>
        </>
        
    )
};

/*
* Function element for items head links of navbar.
* August 19st, 2022
*/
export function ABWHeadLinks({title}) {
    return (
        <>
            <div className='theme--header'>
                <p className="header__title">{title}</p> 
            </div>
            <div className="subheader__pics">
                <img src={RegVinL}  alt="Header of region pic" srcSet={`${RegVinXS} 400w, ${RegVinS} 800w, ${RegVinM} 1200w, ${RegVinL} 1600w, ${RegVinXL} 2000w, ${RegVinXXL} 3500w`}  
                sizes="(max-width: 500px) 500px, (max-width: 800px) 800px, (max-width: 1200px) 1200px, (max-width: 1600px) 1600px, (max-width: 1920px) 2000px, (max-width: 3500px) 3500px, 2000px"/> 
            </div>
            
        </>
    )
};

/*
* Function element for items head links of navbar.
* August 19st, 2022
*/
export function SWHeadLinks({title}) {
    return (
        <>
            <div className='theme--header'>
                <p className="header__title">{title}</p> 
            </div>
            <div className="subheader__pics">
                <img src={SwinesL}  alt="Header of region pic" srcSet={`${SwinesXS} 400w, ${SwinesS} 800w, ${SwinesM} 1200w, ${SwinesL} 1600w, ${SwinesXL} 2000w, ${SwinesXXL} 3500w`}  
                sizes="(max-width: 500px) 500px, (max-width: 800px) 800px, (max-width: 1200px) 1200px, (max-width: 1600px) 1600px, (max-width: 1920px) 2000px, (max-width: 3500px) 3500px, 2000px"/> 
            </div>
            
        </>
    )
}

/*
* Function element for items head links of navbar.
* August 19st, 2022
*/
export function DWHeadLinks({title}) {
    return (
        <>
            <div className='theme--header'>
                <p className="header__title">{title}</p> 
            </div>
            <div className="subheader__pics">
                <img src={DWL}  alt="Header of region pic" srcSet={`${DWXS} 400w, ${DWS} 800w, ${DWM} 1200w, ${DWL} 1600w, ${DWXL} 2000w, ${DWXXL} 3500w`}  
                sizes="(max-width: 500px) 500px, (max-width: 800px) 800px, (max-width: 1200px) 1200px, (max-width: 1600px) 1600px, (max-width: 1920px) 2000px, (max-width: 3500px) 3500px, 2000px"/> 
            </div>
            
        </>
    )
};

/*
* Function element for items head links of navbar.
* August 19st, 2022
*/
export function VitHeadLinks({title}) {
    return (
        <>
            <div className='theme--header'>
                <p className="header__title">{title}</p> 
            </div>
            <div className="subheader__pics">
                <img src={VitL}  alt="Header of region pic" srcSet={`${VitXS} 400w, ${VitS} 800w, ${VitM} 1200w, ${VitL} 1600w, ${VitXL} 2000w, ${VitXXL} 3500w`}  
                sizes="(max-width: 500px) 500px, (max-width: 800px) 800px, (max-width: 1200px) 1200px, (max-width: 1600px) 1600px, (max-width: 1920px) 2000px, (max-width: 3500px) 3500px, 2000px"/> 
            </div>
            
        </>
    )
};


/*
* Function element for items head links of navbar.
* August 19st, 2022
*/
export function TipHeadLinks({title}) {
    return (
        <>
            <div className='theme--header'>
                <p className="header__title">{title}</p> 
            </div>
            <div className="subheader__pics">
                <img src={VitL}  alt="Header of region pic" srcSet={`${TiptXS} 400w, ${TiptS} 800w, ${TiptM} 1200w, ${TiptL} 1600w, ${TiptXL} 2000w, ${TiptXXL} 3500w`}  
                sizes="(max-width: 500px) 500px, (max-width: 800px) 800px, (max-width: 1200px) 1200px, (max-width: 1600px) 1600px, (max-width: 1920px) 2000px, (max-width: 3500px) 3500px, 2000px"/> 
            </div>
            
        </>
    )
};
